import {GatewayEditor} from "./GatewayEditor";
import {ProcessNodeEditor} from "./ProcessNodeEditor";

export class XorGatewayEditor extends GatewayEditor {
	constructor(parent, node, coords) {
		super(parent, node, coords);
	}

	/**
	 * Generate a name for newly created connection
	 * @param {PConnection[]} currentConnections
	 * @return {PEdge}
	 */
	generateOutgoingEdge(currentConnections) {
		let edgeId;
		if (!ProcessNodeEditor.containsEdgeId(currentConnections, "THEN")) edgeId = "THEN";
		else if (!ProcessNodeEditor.containsEdgeId(currentConnections, "ELSE")) edgeId = "ELSE";
		else edgeId = ProcessNodeEditor.randomEdgeId(currentConnections, "edge-");	// this will be invalid edge name

		return {
			id: edgeId,
			"class": "com.anneca.intouch.workflow.edge.SimpleEdge"
		};
	}

	drawTypeSymbol(ctx, rect) {
		/*
		ctx.save();
		ctx.lineWidth = 3 * this.lineWidth;

		ctx.strokeStyle=this.typeColor;
		ctx.beginPath();
		ctx.moveTo(rect.left + rect.width / 3, rect.top + rect.height / 3);
		ctx.lineTo(rect.left + 2/3*rect.width, rect.top + 2/3*rect.height);
		ctx.moveTo(rect.left + 2/3*rect.width, rect.top + rect.height / 3);
		ctx.lineTo(rect.left + 1/3*rect.width, rect.top + 2/3*rect.height);
		ctx.stroke();

		ctx.restore();
		*/
	}

}